"use client";
import { useEffect } from "react";
import clarity from "@microsoft/clarity";

export default function ClarityAnalytics() {
  useEffect(() => {
    clarity.init("v3v0tu6dtn");
  }, []);

  return null;
}
